import type {SearchCriteriaRaw} from '../../../types';
import {createExpirationRule} from '../expirationRule';
import type {ExpirationRule, TSearchTypeExpiration} from '../types';

export type RawExpirationSearchCriteria =
	SearchCriteriaRaw<TSearchTypeExpiration>;

export const rawExpirationCriteriaToRuleObject = (
	criteria: RawExpirationSearchCriteria,
): ExpirationRule => {
	return createExpirationRule();
};

export default rawExpirationCriteriaToRuleObject;
